// import { commonUtils } from '@/helpers/commonUtils'
// import { pptTimestamp, pptLogo } from '../../PPTBox'
// import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
// import { genPx } from '../../doPPTExport'
import styles from './PptPage1.module.less'
import PptPage, { PageHeader } from '../PptPage/PptPage'
import { commonUtils } from '@/helpers/commonUtils'
import { useEffect, useRef, useState } from 'react'
import { SliderModels } from '@/types/slider'

interface Props {
  project: ProjectModels.ProjectDetail
  no: number
  onSliderReady: (slider: SliderModels.Slider, no: number) => void
}

function PptPage1({ project, no, onSliderReady }: Props) {
  const { t } = useTranslation()
  const [basicSlider, setBasicSlider] = useState<SliderModels.Slider>()
  const [pageHeaderElements, setPageHeaderElements] = useState<SliderModels.PPTElement[]>([])
  const [elements, setElements] = useState<SliderModels.PPTElement[]>([])
  const [pageRect, setPageRect] = useState<DOMRect>()
  const lineRef = useRef<HTMLDivElement>(null)
  const titleRef = useRef<HTMLDivElement>(null)
  const descRef = useRef<HTMLDivElement>(null)
  const nextRef = useRef<HTMLImageElement>(null)
  const onPageRender = (slider: SliderModels.Slider, pageRect: DOMRect) => {
    setBasicSlider(slider)
    setPageRect(pageRect)
  }
  const onPageHeaderRender = (elements: SliderModels.PPTElement[]) => {
    setPageHeaderElements(elements)
  }

  useEffect(() => {
    if (!lineRef.current || !titleRef.current || !descRef.current || !nextRef.current) {
      return
    }
    const lineRect = lineRef.current?.getBoundingClientRect()
    const titleRect = titleRef.current?.getBoundingClientRect()
    const descRect = descRef.current?.getBoundingClientRect()
    const nextRect = nextRef.current?.getBoundingClientRect()
    const elements: SliderModels.PPTElement[] = [
      {
        type: 'line',
        start: [0, 0],
        end: [lineRect.width, 0],
        style: 'solid',
        color: '#2A2C3F',
        x: lineRect.left,
        y: lineRect.top + 50,
        width: lineRect.height,
        points: ['', ''],
      },
      {
        type: 'text',
        content: titleRef.current.outerHTML,
        width: titleRect.width,
        height: titleRect.height,
        x: titleRect.left,
        y: titleRect.top,
      },
      {
        type: 'text',
        content: descRef.current.outerHTML,
        width: descRect.width,
        height: descRect.height,
        x: descRect.left,
        y: descRect.top,
      },
      {
        type: 'image',
        src: commonUtils.getImagePath('PDFDownload/pdf-page-1/next.png'),
        width: nextRect.width,
        height: nextRect.height,
        x: nextRect.left,
        y: nextRect.top,
      },
    ]
    setElements(elements)
  }, [])

  useEffect(() => {
    if (!pageRect || !basicSlider || pageHeaderElements.length === 0 || elements.length === 0) {
      return
    }
    const _pageHeaderElements = pageHeaderElements.map((element) => {
      const { x, y } = element
      return {
        ...element,
        x: x - pageRect.left,
        y: y - pageRect.top,
      }
    })
    const _elements = elements.map((element) => {
      const { x, y } = element
      return {
        ...element,
        x: x - pageRect.left,
        y: y - pageRect.top,
      }
    })
    const slider: SliderModels.Slider = {
      ...basicSlider,
      elements: [..._pageHeaderElements, ...basicSlider.elements, ..._elements],
    }
    onSliderReady(slider, no)
  }, [basicSlider, pageRect, elements, pageHeaderElements])

  return (
    <PptPage
      no={no}
      bgSrc={commonUtils.getImagePath('PPTDownload/bg-1.jpg')}
      onPageRender={onPageRender}
    >
      <div className={styles.pptPage1}>
        <PageHeader project={project} onRender={onPageHeaderRender} />
        <div className={styles.briefLine} ref={lineRef}></div>
        <p className={styles.title}>
          <span ref={titleRef} style={{ fontSize: '100px', color: '#2A2C3F', fontWeight: 'bold' }}>
            {project.adName}
          </span>
        </p>
        <p className={styles.desc}>
          <span ref={descRef} style={{ fontSize: '32px', lineHeight: '44px', color: '#757576' }}>
            {t('landing.info.title')}
          </span>
        </p>
        <img
          ref={nextRef}
          className={styles.next}
          src={commonUtils.getImagePath('PDFDownload/pdf-page-1/next.png')}
          alt=''
        />
      </div>
    </PptPage>
  )
}

export default PptPage1
